/**
 * 站点主品牌 logo（logo_img / logo_img_light）仅在首页路由展示
 */
export default {
  computed: {
    showSiteBrandLogo() {
      return this.$route && this.$route.name === "home";
    },
  },
};
